import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { registerServiceWorker } from "@/pwa/registerServiceWorker";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// PWA: rejestracja Service Workera tylko w produkcyjnym buildzie.
// W DEV zwraca natychmiast — patrz /app/frontend/src/pwa/registerServiceWorker.js
registerServiceWorker();
